var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.438 1.803a.943.943 0 011.341 0 .965.965 0 010 1.355l-3.83 3.868h2.068c.551.001.998.43.998.96 0 .528-.446.957-.997.958H11.77a.23.23 0 01-.028-.003l-.027-.003c-.007 0-.014.002-.02.003a.242.242 0 01-.02.002c-.524 0-.949-.458-.948-1.022V3.572c0-.564.425-1.021.949-1.022.524 0 .948.458.948 1.022v2.082l3.813-3.851zM3.098 16.777a.943.943 0 01-1.342 0 .965.965 0 010-1.355l3.83-3.869H3.518c-.551 0-.998-.429-.998-.958 0-.53.446-.958.997-.959h4.247c.01 0 .02.001.029.003a.222.222 0 00.026.003c.007 0 .014-.002.02-.003l.02-.002c.524 0 .949.457.948 1.022v4.349c0 .564-.425 1.021-.948 1.022-.525 0-.949-.458-.95-1.022v-2.082l-3.812 3.851z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default ForwardRef;